import { encodeQueryStringValue } from "utils/search/buildSearchLink";

import { isEmpty } from "lodash";
import { normalize } from "normalizr";
import RequestError from "utils/error/request";

export default function callAPI({
	url,
	options = {
		query: {},
		body: {},
		headers: {},
		method: "GET"
	},
	schema
}) {
	const queryString = !isEmpty(options.query)
		? `?${encodeQueryStringValue(options.query)}`
		: "";

	const requestOptions = {
		headers: options.headers || {},
		method: options.method || "GET",
		body: options.body ? JSON.stringify(options.body) : undefined
	};

	return fetch(`${url}${queryString}`, requestOptions)
		.then(async (res) => {
			try {
				if (res.status === 401 || res.status === 403) {
					return {
						status: res.status,
						statusText: res.statusText
					};
				}
				return res.json();
			} catch (error) {
				// eslint-disable-next-line no-console
				console.log(
					`Request made to API (${url}${queryString}) is not valid JSON.\n\n\n Response:\n${res.text()}`
				);
				throw error;
			}
		})
		.then((data) => {
			if (schema) {
				// If the response is unauthorized or forbidden, return the status and status text
				if (data.status === 401 || data.status === 403) {
					return {
						status: data.status,
						statusText: data.statusText
					};
				}
				return {
					...normalize(data, schema),
					meta: data.meta || {},
					staticMapUrl: data.staticMapUrl
				};
			}
			return data;
		})
		.catch((error) => {
			throw new RequestError(error);
		});
}
